<template>
  <sAlert small>
    <KeyValue
      :caption="$t('Tenders.RecalculationDate')">
      <span v-if="value.Date">
        {{ $d(new Date(value.Date), 'shortDate') }} 
        {{ $d(new Date(value.Date), 'time') }}
      </span>
      <span v-else>–</span>
    </KeyValue>
    <ul slot="desc">
      <li
        v-for="(item, index) in value.Rates || []"
        :key="`rate-${index}`">
        {{ item.Code }}: {{ item.Rate }}
      </li>
    </ul>
  </sAlert>
</template>
<script>
import KeyValue from 'components/common/KeyValue.vue'

export default {
  name: 'eventHistoryCurrencyRateRecalculationParams',
  components: {
    KeyValue
  },
  props: {
    value: {
      type: Object
    }
  },
}
</script>
